import UserMenu from 'components/common/UserMenu';
import LeftMenu from 'components/common/LeftMenu';

import UserProfileMenu from 'components/UserProfileComponents/ProfileMenu/UserProfileMenu';
import UserProfileArea from 'components/UserProfileComponents/ProfileContent/UserProfileArea/UserProfileArea';
import { useEffect, useState } from 'react';

const UserProfile = () => {
  useEffect(() => {
    document.title = 'Userprofile'; // Update the title when Register component mounts
    window.scrollTo(0, 0);
  }, []);

  const [activeTab, setActiveTab] = useState('personal_info');
  const handleTabClick = (tab) => {

    console.log('Tab clicked:', tab);
    setActiveTab(tab);
  };

  return (
    <>
      <UserMenu />
      <LeftMenu />
      <UserProfileMenu 
        activeTab={activeTab}
        onTabClick={handleTabClick}
      />
      <UserProfileArea 
        activeTab={activeTab}
      />
    </>
  );
};

export default UserProfile;
